import {
  ButtonBase,
  Card,
  Checkbox,
  ClickAwayListener,
  makeStyles,
  Popper,
  Typography,
} from '@material-ui/core';
import { KeyboardArrowDown } from '@material-ui/icons';
import { SearchBlock } from 'components/Common/SearchBlock';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  radio: {
    color: '#c8c8c8',
    '&$checked': {
      color: '#7467F0',
    },
  },
  borderedField: {
    flex: 1,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    fontSize: '1rem',
    padding: '18.5px 14px',
    cursor: 'pointer',
    color: '#909090',
    '&:hover': { borderColor: '#000000' },
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
}));

const ConditionalSelectionField = (props) => {
  const classes = useStyles();
  const [active, setActive] = React.useState(false || !!props.value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [localState, setLocalState] = React.useState([]);
  const selection = ((props.column || {}).selections || {})[props._key];

  const queryFunction = (searchString, searchResults, setList) => {
    if ((searchString || '').length !== 0) {
      let searchRegExp = new RegExp((searchString || '').toLowerCase());

      setList(
        selection.filter((item) =>
          searchRegExp.test(`${item.title || ''}`.toLowerCase())
        )
      );
    } else {
      setList(selection);
    }
  };

  const checkSelected = (item) => {
    return !!(props.value || localState || []).find(
      (option) => option === item.id
    );
  };

  const checkSelectAll = () => {
    return (props.value || localState || []).length === selection.length;
  };

  const selectAllHandle = () => {
    if (checkSelectAll()) {
      (props.onChange || (() => {}))([]);
      setLocalState([]);
    } else {
      (props.onChange || (() => {}))([
        ...(selection || []).map((item) => item.id),
      ]);
      setLocalState([...(selection || []).map((item) => item.id)]);
    }
  };

  const onSelect = (selectedItem) => {
    const newState = props.multiselect
      ? !!(props.value || localState || []).find(
          (option) => option === selectedItem.id
        )
        ? (props.value || localState || []).filter(
            (item) => item !== selectedItem.id
          )
        : [...(props.value || localState || []), selectedItem.id]
      : selectedItem.id;

    props.onChange(newState);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 50,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox
            checked={active}
            size="small"
            onClick={() => setActive(!active)}
            style={{ padding: 2 }}
          />
          <Typography variant="subtitle2">{props.title}</Typography>
        </div>
        <ButtonBase
          onClick={(event) => setAnchorEl(event.currentTarget)}
          disabled={!active}
          style={{
            margin: '0px 10px',
            width: 120,
            maxWidth: 120,
            display: 'flex',
            justifyContent: 'space-between',
            border: '1px solid #e0e0e0',
            borderRadius: 7,
            padding: '2px 7px 2px 9px',
          }}
        >
          <Typography
            style={{ color: active ? '#505050' : '#c5c5c5' }}
            variant="subtitle2"
          >
            {props.multiselect
              ? (props.value || []).length === 0
                ? props.hint
                : `(${(props.value || []).length}) items selected`
              : !props.value
              ? props.hint
              : (
                  (selection || []).find((item) => item.id === props.value) ||
                  {}
                ).title}
          </Typography>
          <KeyboardArrowDown
            style={{
              fontSize: 25,
              color: active ? '#909090' : '#e5e5e5',
              pading: 0,
            }}
          />
        </ButtonBase>
      </div>
      <Popper
        label={props.title}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: '30vw',
        }}
        className={classes.popper}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card elevation={8}>
            <SearchBlock
              onSelect={onSelect}
              selection={selection}
              checkSelected={checkSelected}
              multiselect={props.multiselect}
              checkSelectAll={checkSelectAll}
              queryFunction={queryFunction}
              selectAllHandle={selectAllHandle}
            />
          </Card>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default ConditionalSelectionField;
